import { getCookieValue } from "./helperServices";
const HttpsProxyAgent =
  typeof window === "undefined" ? require("https-proxy-agent") : "";

const config = require("../config/index");
const env = config.env;
import { getGraphQlOperationFromRequestQuery } from '../config/queries';
import { handleMagentoResponse } from "../utils/magentoService";

import {
  Logger,
} from "../utils/logger";
import { sha256 } from "../components/atoms/DependencyHelper";

const httpGet = (
  baseUrl,
  params,
  mode = "stub",
  requestId,
  reqParams,
  responseType = "json"
) => {
  if (mode === "api") {
    const server = config.envConfigs[env].server;
    const serverDomain = config.envConfigs[env].serverDomain;
    let url = (env == 'dev' || baseUrl == 'featureBaseUrl') ? `${server}${config[baseUrl]}${config[mode][requestId]}` : `${serverDomain}${config[mode][requestId]}`;

    if (reqParams && url.indexOf("{reqParams}") < 0) {
      url = `${url}/{reqParams}`;
      url = url.replace("{reqParams}", reqParams.join("/"));
    }

    if (params && url.indexOf("{param}") < 0) {
      url = `${url}?{param}`;
      url = url.replace("{param}", params);
    }
    const headers = { "Content-Type": "application/json" };

    let opts;
    if (
      url.toLowerCase().startsWith("https:") &&
      typeof window === "undefined"
    ) {
      // const https = require("https");
      const agent = HttpsProxyAgent(config.envConfigs[env].drupalApi.proxy);
      // const agent = new https.Agent({
      //   rejectUnauthorized: false,
      //   servername: "http://vod-ms-egress-proxy:3128"
      // });
      opts = {
        method: "GET",
        headers,
        agent,
      };
    } else {
      opts = {
        method: "GET",
        headers,
      };
    }

    return fetch(url, opts)
      .then(async res => {

        let ret = responseType == "text"
          ? await res.text()
          : await res.json();

        if (!res?.ok) {

          Logger.error(
            ret.error || ret.message || `Failed to fetch ${url}`,
            "httpGet",
            {
              request: {
                baseUrl,
                params: JSON.stringify(params || {}),
                mode,
                requestId,
                reqParams: JSON.stringify(reqParams || {}),
                responseType
              },
              requestUrl: url,
              response: (responseType !== "text" && JSON.stringify(ret)) || "HTML Response - unable to display",
              responseStatus: `${res.status} - ${res.statusText}`,
              options: opts,
            }
          );
        }

        return ret;
      })
  }
};

const httpPost = (
  baseUrl,
  data,
  mode = "stub",
  requestId,
  authNeed = false
) => {
  if (mode === "api") {
    const authToken = getCookieValue("auth_token");
    const server = config.envConfigs[env].server;
    const serverDomain = config.envConfigs[env].serverDomain;

    let url = (env == 'dev') ? `${server}${config[baseUrl]}${config[mode][requestId]}` : `${serverDomain}${config[mode][requestId]}`;

    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    if (authToken && authNeed) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    let opts;
    if (
      url.toLowerCase().startsWith("https:") &&
      typeof window === "undefined"
    ) {
      const agent = HttpsProxyAgent(config.envConfigs[env].drupalApi.proxy);

      opts = {
        method: "POST",
        headers,
        body: data,
        agent,
      };
    } else {
      opts = {
        method: "POST",
        headers,
        body: data,
      };
    }

    return fetch(url, opts)
      .then(res => {

        if (!res?.ok) {

          Logger.error(
            `Failed to fetch ${url}`,
            "httpPost",
            {
              request: {
                baseUrl,
                data: JSON.stringify(data || {}),
                mode,
                requestId,
                authNeed
              },
              requestUrl: url,
              responseStatus: `${res.status} - ${res.statusText}`,
              options: opts,
            }
          );
        }

        return res.json();
      })
      .then(rsp => {
        if(typeof window === "undefined"){
          console.log("vod-ms-web-ecom-ui", JSON.stringify({
            request: {
              url: url,
              ...opts,
            },
            response: rsp,
          }));
        }
        return rsp;
      });
  }
};


const httpPostGrpahQL = (
  baseUrl,
  data,
  mode = "stub",
  requestId,
  authNeed = false
) => {
  if (mode === "api") {
    const authToken = getCookieValue("auth_token");
    const server = config.envConfigs[env].server;
    let url = (env == 'dev') ? `${server}${config[baseUrl]}${config[mode][requestId]}` : `${config.envConfigs[config.env].dxl.url}${config[mode][requestId]}`;

    console.log("httpPostGrpahQL URL: ", url);

    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    if (authToken && authNeed) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    let opts;
    if (
      url.toLowerCase().startsWith("https:") &&
      typeof window === "undefined"
    ) {
      const agent = HttpsProxyAgent(config.envConfigs[env].drupalApi.proxy);

      opts = {
        method: "POST",
        headers,
        body: data,
        agent,
      };
    } else {
      opts = {
        method: "POST",
        headers,
        body: data,
      };
    }

    return fetch(url, opts)
      .then(res => {

        if (!res?.ok) {

          Logger.error(
            `Failed to fetch ${url}`,
            "httpPostGrpahQL",
            {
              request: {
                baseUrl,
                data: JSON.stringify(data || {}),
                mode,
                requestId,
                authNeed
              },
              requestUrl: url,
              responseStatus: `${res.status} - ${res.statusText}`,
              options: opts,
            }
          );
        }
        return res.json();
      })
      .then(rsp => {
        if(typeof window === "undefined"){
          console.log("vod-ms-web-ecom-ui", JSON.stringify({
            request: {
              url: url,
              ...opts,
            },
            response: rsp,
          }));
        }
        return rsp;
      });
  }
};


const fetchGraphQLGetRequest = (query, variables, signal) => {
  const server = config.envConfigs[env].server;
  const url = (env == 'dev') ? `${server}${config.graphqlUrl}` : `${config.envConfigs[config.env].graphql.url}`;

  const authToken = getCookieValue("auth_token");
    let headers = {};
    if(authToken) {
          headers = {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "store": "cbu",
            "Authorization": `Bearer ${authToken}`,
          };
        } else {
          headers = {
            "Content-Type": "application/json",
            "store": "cbu",
            "Accept": "application/json",
          };
        }
  let opts = {};
  if (url.toLowerCase().startsWith("https:") && typeof window === "undefined") {
    const agent = HttpsProxyAgent(config.envConfigs[env].graphql.proxy);
    opts = {
      method: "GET",
      headers,
      agent,
    };
  } else {
    opts = {
      method: "GET",
      headers,
    };
  }
  if(signal){
    opts.signal = signal;
  }
  let getUrl = url +'?query=' + query;
  if(variables){
    getUrl = getUrl+'&variables='+JSON.stringify(variables)
  }

  let finalURL = getUrl.trim();
  let response;
  return fetch(encodeURI(finalURL), opts)
    .then(resData => resData.json())
    .then(res => {
      const responseStatus = handleMagentoResponse(res);
      if (!responseStatus?.ok) {

        Logger.error(
          responseStatus.error || responseStatus.message || `Failed to fetch ${url}`,
          "fetchGraphQLGetRequest",
          {
            requestUrl: finalURL,
            response: JSON.stringify(responseStatus),
            options: opts,
          }
        );
      }
      response = responseStatus;
      return responseStatus;
    })
    .then(rsp => {
      if(typeof window === "undefined") {
        console.log("vod-ms-web-ecom-ui", JSON.stringify({
          request: {
            url: encodeURI(finalURL),
            ...opts,
          },
          response: rsp,
        }));
      }
      if (!rsp.data) {
        return {...rsp, status: response.status};
      } else {
        return {...rsp.data, status: response.status};
      }
    }).catch(function(e) {
      Logger.error(e);

      Logger.error(
        e,
        "fetchGraphQLGetRequest",
        {
          requestUrl: finalURL,
          options: opts,
        }
      );

      if (e.name === 'AbortError') {
        console.log('Promise Aborted');
      }
    })
};


const httpPdfGet = (baseUrl, requestUrl) => {
  let url = noCorsUrl(baseUrl, requestUrl);
  const headers = { "Content-Type": "application/pdf" };

  let opts;
  if (url.toLowerCase().startsWith("https:") && typeof window === "undefined") {
    // const https = require("https");
    const agent = HttpsProxyAgent(config.envConfigs[env].graphql.proxy);
    // const agent = new https.Agent({
    //   rejectUnauthorized: false,
    // });
    opts = {
      method: "GET",
      headers,
      agent,
    };
  } else {
    opts = {
      method: "GET",
      headers,
    };
  }
  return fetch(url, opts)
    .then(res => {
      if (!res?.ok) {
        Logger.error(new Error(`Failed to fetch ${url}`));
      }
      return res.blob();
    })
    .then(rsp => {
      return rsp;
    });
};

const noCorsUrl = (baseUrl, requestUrl) => {
  const server = config.envConfigs[env].server;
  let newRequestUrl = "";

  if (baseUrl !== "drupalBaseUrl") {
    newRequestUrl = requestUrl.replace(config.envConfigs[env].graphql.url, "/");
  } else {
    newRequestUrl = requestUrl.replace(
      config.envConfigs[env].drupalApi.url,
      "/"
    );
  }
  return `${server}${config[baseUrl]}${newRequestUrl}`;
};

const httpAuthGet = (baseUrl, params, mode = "stub", requestId, reqParams) => {
  if (mode == "stub") {
    // const resquestedService = require(`../data/${requestId}`);
    //  return resquestedService.default.data;
  } else if (mode == "api") {
    const envConfig = config.envConfigs[env];
    const server = envConfig.server;
    const serverDomain = config.envConfigs[env].serverDomain;

    let url = (env == 'dev') ? `${server}${config[baseUrl]}${config[mode][requestId]}` : `${serverDomain}${config[mode][requestId]}`;
    const auth = `Basic ${envConfig["drupalApi"]["auth"]}`;

    if (reqParams && url.indexOf("{reqParams}") < 0) {
      url = `${url}/{reqParams}`;
      url = url.replace("{reqParams}", reqParams.join("/"));
    }

    if (params && url.indexOf("{param}") < 0) {
      url = `${url}?{param}`;
      url = url.replace("{param}", params);
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: auth,
    };

    let opts;
    if (
      url.toLowerCase().startsWith("https:") &&
      typeof window === "undefined"
    ) {
      // const https = require("https");
      const agent = HttpsProxyAgent(config.envConfigs[env].graphql.proxy);
      // const agent = new https.Agent({
      //   rejectUnauthorized: false,
      // });
      opts = {
        method: "GET",
        headers,
        agent,
      };
    } else {
      opts = {
        method: "GET",
        headers,
      };
    }
    return fetch(url, opts)
      .then(res => {
        if (!res?.ok) {
          Logger.error(new Error(`Failed to fetch ${url}`));
        }
        return res.json();
      })
      .then(rsp => {
        if(typeof window === "undefined"){
          console.log("vod-ms-web-ecom-ui", JSON.stringify({
            request: {
              url: url,
              ...opts,
            },
            response: rsp,
          }));
        }
        return rsp;
      });
  }
};

const httpAuthPost = (
  baseUrl,
  data,
  mode = "stub",
  requestId
) => {
  if (mode == "stub") {
    // const resquestedService = require(`../data/${requestId}`);
    // return resquestedService;
  } else if (mode == "api") {
    const envConfig = config.envConfigs[env];
    const server = envConfig.server;
    const serverDomain = config.envConfigs[env].serverDomain;
    const url = (env == 'dev') ? `${server}${config[baseUrl]}${config[mode][requestId]}` : `${serverDomain}${config[mode][requestId]}`;

    const auth = `Basic ${envConfig["drupalApi"]["auth"]}`;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: auth,
      // "X-CSRF-TOKEN": csrfToken,
    };

    let opts;
    if (
      url.toLowerCase().startsWith("https:") &&
      typeof window === "undefined"
    ) {
      // const https = require("https");
      const agent = HttpsProxyAgent(config.envConfigs[env].graphql.proxy);
      // const agent = new https.Agent({
      //   rejectUnauthorized: false,
      // });
      opts = {
        method: "POST",
        headers,
        body: data,
        agent,
      };
    } else {
      opts = {
        method: "POST",
        headers,
        body: data,
      };
    }
    return fetch(url, opts)
      .then(res => {
        if (!res?.ok) {
          Logger.error(new Error(`Failed to fetch ${url}`));
        }
        return res.json();
      })
      .then(rsp => {
        if(typeof window === "undefined"){
          console.log("vod-ms-web-ecom-ui", JSON.stringify({
            request: {
              url: url,
              ...opts,
            },
            response: rsp,
          }));
        }
        return rsp;
      });
  }
};

const fetchGraphQLPOSTRequest = (query, variables, stubUrl = '', nodeGet, signal, requestOptions = {}) => {
  const body = JSON.stringify({ query, variables });

  let url;
  url = `${config.envConfigs[config.env].graphql.url}`;
  const operation = nodeGet? "graphql" :getGraphQlOperationFromRequestQuery(query);
  const authToken = getCookieValue('auth_token');
  let headers = {};

  if (authToken) {
    headers = {
      'Content-Type': 'application/json',
       "Accept": 'application/json',
       'store': 'cbu',
       'Authorization': `Bearer ${authToken}`,
    };
  } else {
    headers = {
      'Content-Type': 'application/json',
       "Accept": 'application/json',
       'store': 'cbu',
    };
  }
  if (stubUrl !== '') {
    const resquestedService = require(`../data/${stubUrl}`);
    return resquestedService.data;
  } else {
    let opts;
    if (
      url.toLowerCase().startsWith('https:') &&
      typeof window === 'undefined'
    ) {
      const agent = HttpsProxyAgent(config.envConfigs[env].graphql.proxy);
      opts = {
        method: 'POST',
        headers,
        body,
        agent,
      };
    } else {
      opts = {
        method: 'POST',
        headers,
        body,
      };
    }
    if(signal){
      opts.signal = signal;
    }
    if(variables && variables.contract_skus){
      url = `${url}?contract_skus=${sha256(variables.contract_skus)}`
    }
    let response;

    if(requestOptions && typeof requestOptions === 'object') {
      if(requestOptions.headers && typeof requestOptions.headers === 'object') {
        opts.headers = {
          ...opts.headers,
          ...requestOptions.headers
        }
      }
    }
    return fetch(url, opts)
      .then(resData => resData.json())
      .then((res) => {

        const responseStatus = handleMagentoResponse(res);

        if (!responseStatus?.ok) {

          Logger.error(
            responseStatus.error || responseStatus.message || `Failed to fetch ${url}`,
            "fetchGraphQLPOSTRequest",
            {
              request: {
                body: JSON.stringify(body || {})
              },
              requestUrl: url,
              response: JSON.stringify(responseStatus),
              options: opts,
            }
          );
        }

        response = responseStatus;
        return responseStatus;
      })
      .then((rsp) => {
        if(typeof window === "undefined"){
          console.log("vod-ms-web-ecom-ui", JSON.stringify({
            request: {
              url: url,
              ...opts,
            },
            operation,
            response: rsp,
          }));
        }

        if (rsp?.data || rsp?.errors) {
          return {...rsp?.data, status: response?.status, errors: rsp?.errors || null};
				} else {
					return {...rsp, status: response?.status};
				}
			})
			.catch((error) => {

        Logger.error(
          error,
          "fetchGraphQLPOSTRequest",
          {
            request: {
              body: JSON.stringify(body || {})
            },
            requestUrl: url,
            options: opts,
          }
        );

        if(typeof window === "undefined"){
          console.log("vod-ms-web-ecom-ui", JSON.stringify({
            request: {
              url: url,
              ...opts,
            },
            operation,
            response: error,
          }));
        }
			});
  }
};

export default {
  httpGet,
  httpPost,
  httpPostGrpahQL,
  fetchGraphQLPOSTRequest,
  fetchGraphQLGetRequest,
  httpPdfGet,
  noCorsUrl,
  httpAuthGet,
  httpAuthPost
};
